import { type SupportedLanguage } from '@/lib/user-language'

export const EMAIL_APP_NAME = 'Ask QIEN'
export const EMAIL_BRAND_COLOR = '#66A573'
export const EMAIL_BRAND_COLOR_DARK = '#4d8a5a'
export const EMAIL_APP_URL = process.env.AUTH_URL ?? process.env.NEXTAUTH_URL ?? 'https://quality-intelligence.co'
export const EMAIL_APP_NAME_HTML = `<span style="font-family:'SFMono-Regular',Consolas,'Liberation Mono',monospace;font-weight:700;color:${EMAIL_BRAND_COLOR};">${EMAIL_APP_NAME}</span>`

const LOGO_URL = 'https://quality-intelligence.co/brand/qi-mark.png'

export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function renderPrimaryEmailButton({
  href,
  label,
  letterSpacing = false,
}: {
  href: string
  label: string
  letterSpacing?: boolean
}) {
  return `<tr>
                  <td align="center" style="padding-bottom:28px;">
                    <a href="${href}"
                       style="display:inline-block;background-color:${EMAIL_BRAND_COLOR};color:#ffffff;text-decoration:none;font-size:15px;font-weight:600;padding:14px 32px;border-radius:8px;${letterSpacing ? 'letter-spacing:0.1px;' : ''}"
                       onmouseover="this.style.backgroundColor='${EMAIL_BRAND_COLOR_DARK}'"
                       onmouseout="this.style.backgroundColor='${EMAIL_BRAND_COLOR}'">
                      ${label}
                    </a>
                  </td>
                </tr>`
}

export function renderFallbackLink({
  href,
  text,
  title,
}: {
  href: string
  text: string
  title?: string
}) {
  const titleHtml = title
    ? `<p style="margin:0 0 6px;font-size:12px;color:#71717a;font-weight:500;text-transform:uppercase;letter-spacing:0.5px;">${title}</p>
                    `
    : ''

  return `<tr>
                  <td style="padding-bottom:24px;border-top:1px solid #f4f4f5;padding-top:20px;">
                    ${titleHtml}<p style="margin:0;font-size:12px;color:#71717a;">${text}</p>
                    <p style="margin:6px 0 0;font-size:11px;word-break:break-all;">
                      <a href="${href}" style="color:${EMAIL_BRAND_COLOR};text-decoration:none;">${href}</a>
                    </p>
                  </td>
                </tr>`
}

export function renderTicketEmailHeader({
  reference,
  title,
  label,
  heading,
}: {
  reference: string
  title: string
  label: string
  heading: string
}) {
  return `<tr>
                  <td style="padding-bottom:4px;">
                    <p style="margin:0;font-size:11px;font-family:monospace;color:#71717a;">${reference}</p>
                  </td>
                </tr>

                <tr>
                  <td style="padding-bottom:20px;">
                    <p style="margin:0;font-size:20px;font-weight:700;color:#18181b;letter-spacing:-0.3px;">${heading}</p>
                  </td>
                </tr>

                <tr>
                  <td style="padding-bottom:16px;">
                    <p style="margin:0;font-size:13px;font-weight:600;color:#52525b;text-transform:uppercase;letter-spacing:0.4px;">${label}</p>
                    <p style="margin:4px 0 0;font-size:15px;color:#18181b;">${title}</p>
                  </td>
                </tr>

                <tr><td style="border-top:1px solid #f4f4f5;padding-bottom:16px;"></td></tr>`
}

export function renderEmailLayout({
  subject,
  language,
  contentHtml,
  maxWidth = 480,
  footerUrl = EMAIL_APP_URL,
  footerLabel = 'quality-intelligence.co',
}: {
  subject: string
  language: SupportedLanguage
  contentHtml: string
  maxWidth?: number
  footerUrl?: string
  footerLabel?: string
}) {
  return `<!DOCTYPE html>
<html lang="${language}">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${subject}</title>
</head>
<body style="margin:0;padding:0;background-color:#f4f4f5;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f4f5;padding:40px 16px;">
    <tr>
      <td align="center">
        <table width="100%" cellpadding="0" cellspacing="0" style="max-width:${maxWidth}px;">
          <tr>
            <td align="center" style="padding-bottom:24px;">
              <img src="${LOGO_URL}" width="64" height="64" alt="${EMAIL_APP_NAME}" style="display:block;border-radius:12px;" />
              <p style="margin:12px 0 0;font-size:18px;">${EMAIL_APP_NAME_HTML}</p>
            </td>
          </tr>
          <tr>
            <td style="background-color:#ffffff;border-radius:12px;border:1px solid #e4e4e7;padding:40px 40px 32px;">
              <table width="100%" cellpadding="0" cellspacing="0">
                ${contentHtml}
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding-top:24px;">
              <p style="margin:0;font-size:12px;color:#a1a1aa;">&copy; ${new Date().getFullYear()} Quality Intelligence &middot; <a href="${footerUrl}" style="color:#a1a1aa;text-decoration:none;">${footerLabel}</a></p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`
}
